export const deleteURLParams = (params_to_be_delete) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    
    params_to_be_delete.forEach(paramName => {
        params.delete(paramName);
    });
    
    url.search = params.toString();
    window.history.replaceState({}, "", url);
}